import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Softskill } from 'app/main/models/softskill/softskill.model';
import { SoftskillService } from 'app/main/services/softskill.service';

@Component({
  selector: 'app-softskill-card',
  templateUrl: './softskill-card.component.html',
  styleUrls: ['./softskill-card.component.scss']
})
export class SoftskillCardComponent implements OnInit {

  @Input() softskill: Softskill;

  showNumber: boolean;
  rating: number;
  imageUrl: string;

  stopRender: boolean;
  isDark: boolean;

  constructor(
    private router: Router,
    private softskillService: SoftskillService
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['softskill']) {
      this.softskill = changes['softskill'].currentValue;
    }
    this.initialize();
  }

  async ngOnInit() {
    this.initialize();
  }

  initialize() {
    if (this.softskill) {
      //this.rating = this.salespackage.averageValue;
      this.showNumber = true;
      // this.imageUrl = 'http://192.168.2.166:8200/exellente/metodi-lettura-tarocchi.jpg';
      this.imageUrl = this.softskillService.retrieveSoftskillImageUrl(this.softskill);
    }
  }

  /*   async goToDetail(subscriptionId) {
      await this.router.navigate(['/common-area/subscription/' + subscriptionId + '/detail']);
    } */

  async goToDetail(softskillId) {
    await this.router.navigate(['/common-area/softskills-offer/' + softskillId + '/detail']);
  }

  /* checkImageRendered() {
    const img: any = document.getElementById(this.imageUrl) as HTMLElement;
    if (img) {
      img.isDark = this.isImageDark(img, 150, 20);
    }
  }

  isImageDark(image, threshold, fuzz) {
    if (!threshold) {
      threshold = 127;
    }
    if (fuzz === undefined || fuzz < 0 || fuzz % 2 !== 0) {
      fuzz = 1;
    }
    const c = document.createElement('canvas');
    const ctx = c.getContext('2d');
    c.width = image.width;
    c.height = image.height;
    image.crossOrigin = 'Anonymous';
    ctx.drawImage(image, 0, 0);

    const data = ctx.getImageData(0, 0, c.width, c.height).data;
    let totalGrey = 0;

    for (let i = 0, ln = data.length, inc = 4 * fuzz; i < ln; i += inc) {
      const r = data[i],
        g = data[i + 1],
        b = data[i + 2],
        grey = Math.floor((r + g + b) / 3);

      totalGrey += grey;
    }

    const area = (c.width * c.height) / fuzz,
      lightLevel = Math.floor(totalGrey / area);
    this.isDark = (lightLevel < threshold);

    return this.isDark;
  } */




}
